import "./IndustryCountryCrawlStyles.scss";
import $ from "jquery";
import { runOnlyOnce } from "../FunctionsCore";
const industryCountryCrawl = runOnlyOnce(() => {
    $(() => {
        $(".show-more").on("click", function (cl) {
            cl.preventDefault();
            const $this = $(this);
            const $container = $this.closest(".container");
            const $moreInfo = $container.find(".more-info");
            const $title = $container.find(".title");
            const viewLessClass = "viewLess";
            const viewMoreClass = "viewMore";
            if ($moreInfo.is(":visible")) {
                $this.attr("aria-label", "Show more industries");
                $this.html('Show More <span class="icon arrow-down"></span>');
                $this.addClass(viewMoreClass);
                $this.removeClass(viewLessClass);
                if (window.matchMedia("only screen and (max-width: 767px)").matches) {
                    $("html, body").animate({
                        "scrollTop": $title.offset().top - 140,
                    }, 2000);
                }
            }
            else {
                $this.blur();
                $this.attr("aria-label", "Show fewer industries");
                $this.html('View Less <span class="icon arrow-up"></span>');
                $this.addClass(viewLessClass);
                $this.removeClass(viewMoreClass);
            }
            $moreInfo.toggleClass("open");
            const $viewLess = $(".viewLess");
            const $viewLessContainer = $viewLess.closest(".container");
            const $viewLessContainerMoreInfo = $viewLessContainer.find(".more-info");
            $viewLessContainerMoreInfo.find(".link-content:first a").focus();
            $viewLessContainerMoreInfo.find("a:first").focus();
        });
        // Corrects overflown text
        $(".locationResults .data").html((_, html) => html.replace(/&nbsp;/g, " "));
    });
});
export { industryCountryCrawl };
